export enum DataState {
    Loading = 'loading',
    Error = 'error',
    Success = 'success',
}
